import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  getAllActivityMembers,
  getAllProjectStatus,
  setActivityStatus,
} from "../../../API/store/actions/projects/projects";
import ModalComponent from "../../reusableComponents/modal";
import Bullets from "../../sharedComponents/bullets/bullets";
import Button from "../../sharedComponents/buttons/button";
import ActivityStatusCard from "./activityStatusCard";

const ActivityStatus = ({ activityId, taskTitle, procAdded, setProcAdded }) => {
  const [members, setMembers] = useState(null);
  const [status, setStatus] = useState(null);
  const [modalVisible, setModalVisible] = useState(null);
  const [projectStatus, setProjectStatus] = useState(null);
  const [StatusId, setStatusId] = useState(null);
  const [changeAll, setChangeAll] = useState(false);

  const modalVisibleFunc = (id) => {
    setStatusId(id);
    setModalVisible(true);
  };

  const userToken = useSelector((state) => state.login.userToken);
  useEffect(() => {
    setActivityStatus(
      activityId,
      changeAll,
      projectStatus,
      resolver,
      getAllActivityMembers,
      setMembers,
      userToken
    );
  }, [projectStatus]);

  useEffect(() => {
    resolver(getAllActivityMembers, setMembers, activityId, userToken);
    resolver(getAllProjectStatus, setStatus, userToken);
  }, []);

  return (
    <>
      <ModalComponent
        body={
          <TaskStatusAlert
            id={StatusId}
            setValue={setProjectStatus}
            setVisible={setModalVisible}
            setChangeAll={setChangeAll}
            procAdded={procAdded}
            setProcAdded={setProcAdded}
          />
        }
        size={"s"}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        hasIcon
        title={"هل انت متاكد"}
        background={"modalBackground mx-5"}
      />
      <div className="mx-5 ">
        <div className="d-flex flex-column flex-lg-row justify-content-between mx-3 ">
          <div style={{ fontSize: 18 }}>{taskTitle}</div>
          <div className="d-flex align-items-center justify-content-center col-lg-3 col-12 mt-lg-0 mt-4">
            {status?.data?.statusLkp.map((item, index) => {
              return (
                <div
                  key={index}
                  className=" d-flex flex-column justify-content-center align-items-center mx-2"
                >
                  <Bullets
                    procAdded={procAdded}
                    setProcAdded={setProcAdded}
                    containerStyle={{ width: 21 }}
                    memberId={activityId}
                    id={item.id}
                    borderColor={"#1a73e8"}
                    bulletColor={item?.color}
                    tooltipTitle={item?.name}
                    setActive={modalVisibleFunc}
                    active={projectStatus ?? members?.data?.projectStatusId}
                  />

                  <div className=" text-center">{item.name} </div>
                </div>
              );
            })}
          </div>
        </div>
        {members?.data?.adminmember?.length > 0 ||
        members?.data?.member?.length > 0 ? (
          <div
            className="my-3  px-2"
            style={{
              boxShadow: "1px 2px 7px grey",
              height: 400,
              overflowY: "auto",
            }}
          >
            <div className="p-3" style={{ color: "#1a73e8" }}>
              المشاركين
            </div>

            {members?.data?.adminmember?.length > 0 ? (
              <div className="px-5 ">
                <div className="my-3">المشاركين الرئيسيين</div>
                {members?.data?.adminmember.map((item, index) => {
                  return (
                    <ActivityStatusCard
                      key={index}
                      member={item}
                      status={status}
                      procAdded={procAdded}
                      setProcAdded={setProcAdded}
                      userToken={userToken}
                      activityId={activityId}
                    />
                  );
                })}
              </div>
            ) : null}
            {members?.data?.member?.length > 0 ? (
              <div className="px-5 ">
                <div className="my-3">المشاركين </div>
                {members?.data?.member.map((item, index) => {
                  return (
                    <ActivityStatusCard
                      key={index}
                      member={item}
                      status={status}
                      procAdded={procAdded}
                      setProcAdded={setProcAdded}
                      userToken={userToken}
                      activityId={activityId}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ActivityStatus;

const TaskStatusAlert = ({ setVisible, setValue, id, setChangeAll }) => {
  const dispatch = useDispatch();
  return (
    <div className=" d-flex flex-column  align-items-center justify-content-center">
      <img src="/assets/images/fi-br-info.png" />
      <div className="my-2">هل تريد تغيير حالة المشاركين أيضًا ؟ </div>
      <div className="d-flex justify-content-center flex-wrap w-100 my-3">
        <Button
          containerStyle={"col-3 mx-2 "}
          content={"نعم"}
          buttonStyleType={"solid"}
          onClick={() => {
            setValue(id);
            dispatch({ type: "RELOAD" });
            setVisible(false);
            setChangeAll(true);
          }}
        />
        <Button
          containerStyle={"col-3 mx-2"}
          content={"لا"}
          onClick={() => {
            setValue(id);
            dispatch({ type: "RELOAD" });
            setVisible(false);
            setChangeAll(false);
          }}
        />
      </div>
    </div>
  );
};
